import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../assets/css/style.css';
import DanLogo from '../assets/img/dan-logo.svg';
import DoneCashback from '../assets/img/DONE-Cashback-System.svg';
import BackIcon from '../assets/img/back-btn.svg';
import EyeIcon from '../assets/img/eye.svg';

function RegformDan() {
  const navigate = useNavigate();

const Opentarms = () => {

navigate("/tarms-reg");

}




  const [formData, setFormData] = useState({
    name: '',
    family: '',
    email: '',
    password: '',
    acceptTerms: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const mobile = localStorage.getItem("mobile");
  const refCode = localStorage.getItem("ref_code");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.acceptTerms) {
      alert("لطفاً قوانین را بپذیرید.");
      return;
    }

    const response = await fetch("https://app.doneapp.ir/backend/register.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        mobile: mobile,
        ref_code: refCode || '',
        name: formData.name,
        family: formData.family,
        email: formData.email,
        password: formData.password
      })
    });

    const result = await response.json();
    if (result.status === "success") {
      localStorage.setItem("donetoken", result.token);
      navigate("/panel/home");
    } else {
      alert(result.message);
    }
  };

  return (
    <>
      <div className="start-bdy">
        <button className="back-btn-1" onClick={() => navigate("/register")}>
          <img src={BackIcon} alt='back' />
        </button>
        <div className="logomotion tw-200">
          <div className="start-logo">
            <img src={DanLogo} alt="Dan Logo" />
            <img className="mt-15" src={DoneCashback} alt="Done Cashback System" />
          </div>
        </div>

        <form className="loginbtns-2" onSubmit={handleSubmit}>
          <div className="btndiv-1">
            <div className="mobileinputdiv-1">
              <input className="mobileinput-1" type="text" name="name" required placeholder="نام خود را وارد کنید" onChange={handleChange} />
            </div>

            <div className="mobileinputdiv-1">
              <input className="mobileinput-1" type="text" name="family" required placeholder="نام خانوادگی خود را وارد کنید" onChange={handleChange} />
            </div>

            <div className="mobileinputdiv-1">
              <input className="mobileinput-1 tal-l" type="email" name="email" required placeholder="ایمیل خود را وارد کنید" onChange={handleChange} />
            </div>

            <div className="mobileinputdiv-1">
              <img className="mobileicon-1" src={EyeIcon} alt="Eye Icon" onClick={() => setShowPassword(!showPassword)} />
              <input className="mobileinput-1" type={showPassword ? "text" : "password"} name="password" required placeholder="برای ورود یک پسورد در نظر بگیرید" onChange={handleChange} />
            </div>

            <div className='tearmsbtn-div'>
              <span>را خوانده‌ام و قبول دارم</span>
              <span onClick={Opentarms} className='color-dan'>قوانین دان &zwnj;</span>
              <div className="checkbox-wrapper">
                <input type="checkbox" id="custom-checkbox" name="acceptTerms" onChange={handleChange} />
              </div>
            </div>

            <button type="submit" className="loginbtn-1">
              ایجاد و ورود به حساب کاربری
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default RegformDan;
